import { motion } from "framer-motion";

export default function PageShell({ children, testId, className = "" }) {
  return (
    <motion.div
      data-testid={testId}
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -12 }}
      transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
      className={`pt-24 pb-16 ${className}`}
    >
      {children}
    </motion.div>
  );
}

export function SectionLabel({ index, children }) {
  return (
    <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500 mb-6">
      [ {String(index).padStart(2, "0")} {"//"} {children} ]
    </p>
  );
}
